export const Style = ({ colors = [] }) => (
  <g id="Estilo3" style={{ opacity: '0.6' }}>
    <path
      id="Longo"
      style={{ fill: colors[0] }}
      d="M78.6,70c0,2.1-1.3,3.3-2.9,3.3s-2.9-1.2-2.9-3.3c0-2.1,1.3-5.2,2.9-5.2 S78.6,67.9,78.6,70z"
    />
  </g>
)
